import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Drawer, Empty} from 'antd';
import {Dayjs} from 'dayjs';

import {Text} from '../../../../component/text/text';
import {NavigationLink} from '../../../../layout/navigation-link/navigation-link';
import {Locale} from '../../../../provider/locale/locale';
import {classNames} from '../../../../util/css';
import {DEFAULT_DATE_FORMAT} from '../../../../util/date';

import {
    ICON_BY_CALENDAR_PUBLICATION_TYPE,
    STATUS_MODIFIER_BY_CALENDAR_POST_STATUS,
    TEXT_BY_CALENDAR_MODERATION,
    TEXT_BY_CALENDAR_POST_STATUS,
    TEXT_BY_CALENDAR_PUBLICATION_TYPE,
} from './posts-calendar-const';
import {getCalendarEntryLink} from './posts-calendar-helper';
import {PostInsideDayCardType} from './posts-calendar-type';
import * as styles from './posts-calendar.scss';

type PropsType = {
    date: Dayjs | null;
    entries: Array<PostInsideDayCardType>;
    onClose: () => void;
};

// A day cell is only wide enough for a truncated name. The drawer is where a day's schedule is
// actually readable: full titles, the publication type and status spelled out, moderation as words
// rather than a marker.
export function PostsCalendarDayDrawer({date, entries, onClose}: PropsType): JSX.Element {
    return (
        <Drawer
            destroyOnClose
            onClose={onClose}
            open={Boolean(date)}
            title={date ? date.format(DEFAULT_DATE_FORMAT) : null}
            width={480}
        >
            {entries.length > 0 ? (
                <ul className={styles.PostCalendar_drawerList}>
                    {entries.map((entry) => (
                        <li className={styles.PostCalendar_drawerItem} key={`${entry.type}-${entry.id}`}>
                            <NavigationLink className={styles.PostCalendar_drawerLink} to={getCalendarEntryLink(entry)}>
                                <FontAwesomeIcon
                                    className={styles.PostCalendar_entryTypeIcon}
                                    icon={ICON_BY_CALENDAR_PUBLICATION_TYPE[entry.type]}
                                />

                                {entry.name}
                            </NavigationLink>

                            <div className={styles.PostCalendar_drawerMeta}>
                                <Text secondary small stringKey={TEXT_BY_CALENDAR_PUBLICATION_TYPE[entry.type]} />

                                <span
                                    className={classNames(
                                        styles.PostCalendar_dot,
                                        STATUS_MODIFIER_BY_CALENDAR_POST_STATUS[entry.status]
                                    )}
                                />

                                <Text secondary small stringKey={TEXT_BY_CALENDAR_POST_STATUS[entry.status]} />

                                {entry.moderation ? (
                                    <Text secondary small stringKey={TEXT_BY_CALENDAR_MODERATION[entry.moderation]} />
                                ) : null}
                            </div>
                        </li>
                    ))}
                </ul>
            ) : (
                <Empty
                    description={<Locale stringKey="POSTS__CALENDAR__DAY_DRAWER__EMPTY" />}
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
            )}
        </Drawer>
    );
}
